export interface Category {
  id: number;
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: 1,
    name: '影视剧女优',
    slug: 'drama-actress',
    description: '活跃在日本电视剧和电影领域的专业女演员，涵盖各大电视台和电影制作公司的签约艺人。',
    icon: 'ri-movie-2-line',
    count: 6,
  },
  {
    id: 2,
    name: '偶像女优',
    slug: 'idol-actress',
    description: '从偶像团体或偶像活动中出身，逐步转型进入影视表演领域的年轻女艺人。',
    icon: 'ri-star-line',
    count: 1,
  },
  {
    id: 3,
    name: '新生代女优',
    slug: 'new-generation',
    description: '2000年前后出生的新一代年轻女演员，代表着日本演艺圈的未来力量。',
    icon: 'ri-sun-line',
    count: 5,
  },
  {
    id: 4,
    name: '实力派女优',
    slug: 'powerhouse-actress',
    description: '以精湛演技著称，在各类作品中展现出色表演功底的资深女演员。',
    icon: 'ri-award-line',
    count: 4,
  },
  {
    id: 5,
    name: '晨间剧女优',
    slug: 'morning-drama',
    description: '曾主演或出演NHK晨间剧的女演员，晨间剧是日本国民级电视剧系列。',
    icon: 'ri-sun-foggy-line',
    count: 3,
  },
  {
    id: 6,
    name: '人气排行榜',
    slug: 'popular-ranking',
    description: '根据网络搜索量、社交媒体热度、作品收视率等综合指标排行的最受欢迎女优。',
    icon: 'ri-fire-line',
    count: 8,
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find(c => c.slug === slug);
};

export const getAllCategories = (): Category[] => {
  return categories;
};